import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { WsGlobalService } from '../http/ws-global.service';

@Injectable()
export class TasaCambioResolver implements Resolve<any> {
    constructor(private wsGlobalService: WsGlobalService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.wsGlobalService.TasaCambio();
    }

}
